import { Swiper } from 'swiper';
import 'swiper/css';

export default function () {
    if (document.querySelector('.last-reviews__posts')) {
        initSwiper();
    }
}

const initSwiper = () => {
    const swiper = new Swiper('.last-reviews__posts', {
        slidesPerView: 1.2,
        spaceBetween: 20,
        enabled: true,
        breakpoints: {
            640: {
                enabled: true,
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            900: {
                enabled: true,
                slidesPerView: 3.1,
                spaceBetween: 16,
            },
            1280: {
                enabled: false,
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    });
};
